// Lønnskjøring (no).
window.PlummeI18n.register('no', {
  // ------------------------------------------------ Lonnskjoring (payroll)
  'pay.overview': 'Lønnsoversikt',
  'pay.overviewSub': 'Registrert lønn for regnskapsåret, gruppert per ansatt.',
  'pay.noPayBasis': 'Ingen lønnsgrunnlag ennå',
  'pay.noPayBasisHint': 'Når lønnskjøringer er godkjent eller utbetalt, vises oversikten her.',
  'pay.noPeriodsHint': 'Arbeidsgiveravgift og forskuddstrekk vises når du har godkjente lønnskjøringer.',
  'pay.noOtpBasisHint': 'Pensjonsgrunnlag vises når du har lønnskjøringer med pensjonsbeløp.',
  'pay.noHolidayPayHint': 'Feriepengegrunnlag vises når du har godkjente lønnskjøringer i valgt periode.',
  'pay.noPayslipsHint': 'Lønnsslipper vises når lønnsutbetalingen har ansatte.',
  'pay.noInboxVouchersHint': 'Bilag som ikke er bokført ennå vises her.',
  'pay.noEntriesHint': 'Regnskapsbilag vises etter at lønnsutbetalingen er godkjent.',
  'pay.noFixedLinesHint': 'Legg inn faste lønnslinjer på ansatte for å bruke dem i lønnskjøring.',
  'pay.salaryTypeSearchHintFull': 'Vanlige typer vises først. Søk eller velg Vis flere for hele den aktive katalogen.',
  'pay.overrideReasonSavedOnLineHint': 'Lagres på lønnslinjen som revisjonsspor.',
  'pay.salaryTypeSearchHintRest': 'Vanlige typer vises først. Søk eller velg Vis flere for resten.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Lagres på den faste linjen.',
  'pay.payPeriodMonthOnlyHint': 'Lønnskjøringer støtter foreløpig månedsperioder.',
  'pay.calculationCodeOtherHint': 'Andre beregningskoder blir tilgjengelige når de er implementert og kontrollert.',
  'pay.runsAndEmployeesInline': '{{runs}} lønnskj. · {{employees}} ansatte',
  'pay.fteShort': 'Årsverk:',
  'pay.taxShort': 'Skatt:',
  'pay.netShort': 'Netto:',
  'pay.holidayPayShort': 'Feriep.:',
  'pay.agaShort': 'AGA:',
  'pay.withholdingHelp': 'Forskuddstrekk — skatten som trekkes fra bruttolønnen og betales til staten på den ansattes vegne.',
  'pay.holidayPayHelp': 'Opptjente feriepenger — vanligvis 10,2 % av lønnsgrunnlaget. Utbetales året etter at de er opptjent.',
  'pay.aga': 'AGA',
  'pay.agaHelp': 'Arbeidsgiveravgift av lønnen — avgift arbeidsgiver betaler til staten i tillegg til lønnskostnaden.',
  'pay.fpShort': 'FP:',
  'pay.agaOfHolidayPay': 'AGA av fp.',
  'pay.agaOfHolidayPayHelp': 'Arbeidsgiveravgift beregnet av de opptjente feriepengene. Avsettes når feriepengene opptjenes.',
  'pay.fte': 'Årsverk',
  'pay.fteHelp': 'Stillingsandel omregnet til hele årsverk. 1,00 = full stilling, 0,50 = halv stilling.',
  'pay.overviewFilteredSub': 'Registrert lønn for regnskapsåret, filtrert på utbetalingsdato.',
  'pay.grouping': 'Gruppering',
  'pay.perEmployee': 'Per ansatt',
  'pay.perSalaryType': 'Per lønnstype',
  'pay.employeeAndType': 'Ansatt og lønnstype',
  'pay.againstWithholding': 'Mot forskuddstrekk',
  'pay.againstAga': 'Mot AGA',
  'pay.postedAs': 'Føres slik:',
  'pay.postedWithholdingOnly': '{{tax}} mot 2600 forskuddstrekk. Åpent før betaling: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} mot 2770 arbeidsgiveravgift. Åpent før betaling: {{openAga}}.',
  'pay.postedBoth': '{{tax}} mot 2600 forskuddstrekk og {{aga}} mot 2770 arbeidsgiveravgift. Åpent før betaling: {{openTax}} skatt og {{openAga}} AGA.',
  'pay.autoPostedAgainstWithholding': 'Betalingen posteres automatisk mot 2600 forskuddstrekk, og krediterer valgt oppgjørskonto.',
  'pay.autoPostedAgainstAga': 'Betalingen posteres automatisk mot 2770 arbeidsgiveravgift, og krediterer valgt oppgjørskonto.',
  'pay.autoPostedAgainstBoth': 'Betalingen posteres automatisk mot 2600 forskuddstrekk og 2770 arbeidsgiveravgift, og krediterer valgt oppgjørskonto.',
  'pay.agreedAnnualSalary': 'Avtalt årslønn',
  'pay.agreedHourlyPay': 'Avtalt timelønn',
  'pay.withholdingSeparatePaymentNote': 'Forskuddstrekk for lønn utbetalt fra 2026 betales separat senest første virkedag etter lønnsutbetalingen.',
  'pay.recommendedForOtpPayment': 'Anbefalt for OTP-betaling',
  'pay.otpPaymentPostingNote': 'Betalingen bokføres mot valgt oppgjørskonto og brukes av Pensjon/OTP-oversikten. Banklinjen kan deretter matches mot betalingsbilaget.',
  'pay.holidayPayAccruedLastYear': 'Feriepenger, opptjent i fjor',
  'pay.holidayPayAccruedThisYear': 'Feriepenger, opptjent i år',
  'pay.ordinaryEmployment': 'Ordinært arbeidsforhold',
  'pay.payslipUncheckAllNote': 'Fjern avhukingen for alle ansatte hvis lønnsslippene skal sendes senere. De kan sendes fra lønnskjøringen etter at regnskapsføringen er godkjent.',
  'pay.payslipPdfNotConnected': 'Lønnsslipp-PDF er ikke koblet til backend.',
  'pay.noSalaryLines': 'Ingen lønnslinjer',
  'pay.deletedOn': 'Slettet {{date}}',
  'pay.payrollPaymentOn': 'Lønnsutbetaling {{date}}',
  'pay.readyLinesForPayroll': '{{count}} godkjente linjer klare til lønn ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'Ingen godkjente linjer klare til lønn.',
  'pay.overrideAppliesFutureRuns': 'Overstyring gjelder fremtidige lønnskjøringer som bruker denne faste linjen.',
  'pay.sentToLabel': 'sendes til',
  'pay.recommendedForPayrollPayment': 'Anbefalt for lønnsutbetaling',
  'pay.optionalNotePh': 'Valgfritt notat ...',
  'pay.openWithholding': 'Åpent forskuddstrekk',
  'pay.openAga': 'Åpen arbeidsgiveravgift',
  'pay.noPeriodPayments': 'Ingen betalinger registrert på terminen ennå.',
  'pay.advance': 'Forskudd',
  'pay.agaAndWithholding': 'Arbeidsgiveravgift og forskuddstrekk',
  'pay.agaAndWithholdingSub': 'Følg opp forskuddstrekk og arbeidsgiveravgift fra godkjente lønnskjøringer per termin.',
  'pay.withholdingLongHelp': 'Skatten du har trukket fra ansattes lønn. Den holdes tilbake på skattetrekkskontoen og betales videre til staten — den er ikke din å bruke.',
  'pay.agaLongHelp': 'Avgift arbeidsgiver betaler til staten av lønn og ytelser. Satsen avhenger av hvilken sone (kommune) virksomheten ligger i — 14,1 % i sone 1.',
  'pay.toAuthority': 'Til Skatteetaten',
  'pay.toAuthorityHelp': 'Forskuddstrekk pluss arbeidsgiveravgift — totalbeløpet som skal betales til staten for terminen.',
  'pay.noPeriods': 'Ingen terminer ennå',
  'pay.period2': 'Termin',
  'pay.payrollRunShort': 'Lønnskj.',
  'pay.pensionOtp': 'Pensjon / OTP',
  'pay.pensionOtpHelp': 'Obligatorisk tjenestepensjon (OTP) er lovpålagt sparing til ansattes pensjon — minst 2 % av lønnen. Her registrerer og følger du opp innbetalingene til pensjonsleverandøren fra godkjente lønnskjøringer.',
  'pay.pensionPayments': 'Pensjonsinnbetalinger',
  'pay.pensionPaymentsSub': 'Registrer og hold oversikt over OTP-betalingene fra godkjente lønnskjøringer.',
  'pay.newPensionPayment': 'Ny pensjonsinnbetaling',
  'pay.calculatedOtp': 'Beregnet OTP',
  'pay.calculatedOtpHelp': 'Samlet beregnet obligatorisk tjenestepensjon for året, fra godkjente lønnskjøringer.',
  'pay.open2': 'Åpent',
  'pay.unpaid': 'Ubetalt',
  'pay.unpaidOtpHelp': 'OTP som er beregnet, men ennå ikke betalt til pensjonsleverandøren.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP som allerede er betalt inn til pensjonsleverandøren.',
  'pay.otpPaidWithDifference': 'Betalt {{paid}} · differanse {{difference}}',
  'pay.noOtpBasis': 'Ingen OTP-grunnlag ennå',
  'pay.payPeriod': 'Lønnsperiode',
  'pay.pensionPayment': 'Pensjonsinnbetaling',
  'pay.otpRefPh': 'F.eks. OTP-06',
  'pay.holidayPayList': 'Feriepengeliste',
  'pay.holidayPayListSub': 'Opptjente og utbetalte feriepenger fra godkjente lønnskjøringer.',
  'pay.holidayPayBasis': 'Feriepengegrunnlag',
  'pay.earned': 'Opptjent',
  'pay.noHolidayPay': 'Ingen feriepenger ennå',
  'pay.paymentDate': 'Utbetalingsdato',
  'pay.holidayPayBasisHelp': 'Summen av lønn som gir rett til feriepenger. Feriepengene beregnes som en prosent av dette grunnlaget.',
  'pay.holidayPayEarnedHelp': 'Feriepenger opptjent hittil — normalt 10,2 % av grunnlaget (12 % ved fem ukers ferie). Utbetales året etter opptjening.',
  'pay.holidayPayPaidHelp': 'Feriepenger som allerede er utbetalt til ansatte i år.',
  'pay.voucherShort': 'Bilag:',
  'pay.paidOutShort': 'Utbet.:',
  'pay.earnedShort': 'Opptjent:',
  'pay.paidShort': 'Utbetalt:',
  'pay.salaryLine': 'Lønnslinje',
  'pay.newLine': 'Opprett ny linje',
  'pay.taxResidentCountry': 'Skattemessig bosatt i land',
  'pay.earningCountry': 'Opptjeningsland',
  'pay.earningRelation': 'Inntjeningsforhold',
  'pay.noPrefill': 'Ikke la beløp/antall være ferdigutfylt for denne linjen i nye lønnsutbetalinger',
  'pay.holidayPayPayout': 'Utbetaling av feriepenger',
  'pay.addHolidayPay': 'Legg til feriepenger',
  'pay.earnedEarlier': 'Opptjent tidligere',
  'pay.earnedThisYear': 'Opptjent i år',
  'pay.pensionContribution': 'Tilskudd/premie til pensjon',
  'pay.registerPensionContribution': 'Registrer tilskudd/premie til pensjon',
  'pay.fetchNavRefunds': 'Hent refusjoner fra NAV',
  'pay.fetchNavRefundsSub': 'Hent refusjoner som skal tas med i lønnsutbetalingen.',
  'pay.emailPayslips': 'Send lønnsslipper på e-post',
  'pay.sendPayslips': 'Send lønnsslipper',
  'pay.sendLater': 'Send senere',
  'pay.sendPayslip': 'Send lønnsslipp',
  'pay.sendAllPayslips': 'Send til alle',
  'pay.sending': 'Sender ...',
  'pay.payslipSendFailed': 'Kunne ikke sende lønnsslipp.',
  'pay.payslipSendUnavailable': 'Utsending av lønnsslipp er ikke koblet til backend.',
  'pay.downloadPayslip': 'Last ned lønnsslipp',
  'pay.downloadAllPdf': 'Last ned alle (PDF)',
  'pay.downloading': 'Laster ned ...',
  'pay.sendTime': 'Tidspunkt for utsendelse',
  'pay.payslipsAfterPosting': 'Lønnsslipper kan lastes ned etter at lønnsutbetalingen er regnskapsført.',
  'pay.noPayslipsShort': 'Ingen lønnsslipper',
  'pay.paymentInfo': 'Informasjon om utbetaling',
  'pay.copyToClipboard': 'Kopier til utklippstavle',
  'pay.downloadExcel': 'Last ned Excel',
  'pay.registerPayment': 'Registrer utbetaling',
  'pay.paymentsFromOperating': 'Utbetalinger fra driftskonto:',
  'pay.toBankAccount': 'Til bankkonto',
  'pay.paidOutDate': 'Utbetalt dato',
  'pay.bankTip': 'Tips! Ikke glem å gjøre selve utbetalingen av forskuddstrekk og lønn i nettbanken.',
  'pay.linkVoucher': 'Knytt bilag',
  'pay.noInboxVouchers': 'Ingen bilag i innboksen',
  'pay.newSalaryLine': 'Ny lønnslinje',
  'pay.paidOutVerb': 'Utbetales',
  'pay.agaShort2': 'Aga',
  'pay.holiday': 'Ferie',
  'pay.noExtraLines': 'Ingen ekstra lønnslinjer er lagt til ennå.',
  'pay.showEmployeePage': 'Vis ansatt-side',
  'pay.addSalaryLine': 'Legg til lønnslinje',
  'pay.noEmployeesInRun': 'Ingen ansatte i lønnsutbetalingen',
  'pay.holidayPensionDeductions': 'Feriepenger, pensjon og fradrag',
  'pay.pensionContributionOrPremium': 'Tilskudd eller premie til pensjon',
  'pay.summary': 'Sammendrag',
  'pay.payrollRun': 'Lønnsutbetaling',
  'pay.agaRate': 'Arb.avgift (14,1 %)',
  'pay.posting': 'Regnskapsføring',
  'pay.writeComment': 'Skriv en kommentar',
  'pay.seePayslips': 'Se lønnsslipper',
  'pay.nextStep': 'Neste steg',
  'pay.sendAmeldingToAltinn': 'Send a-melding til Altinn',
  'pay.deletePayrollRun': 'Slett lønnsutbetaling',
  'pay.manualSubmission': 'Manuell innsending',
  'pay.sendAmelding': 'Send a-melding',
  'pay.altinnConfirmation': 'Bekreftelse fra Altinn',
  'pay.altinnConfirmationHelp': 'Når A-meldingen er sendt, venter du på bekreftelse før lønnsslippene opprettes.',
  'pay.createPayslips': 'Opprett lønnsslipper',
  'pay.editPayrollRun': 'Endre lønnsutbetaling',
  'pay.registerPaymentToEmployees': 'Registrer betaling til ansatte og skatt',
  'pay.cancelPosting': 'Annuller regnskapsføringen',
  'pay.cancelPostingConfirmTitle': 'Annullere regnskapsføringen?',
  'pay.cancelPostingConfirmMessage': 'Dette tar lønnsutbetalingen tilbake til utkast. Registrerte utbetalinger og selve regnskapsføringen annulleres og fjernes fra aktive regnskapstall. Du må kontrollere og godkjenne lønnen på nytt.',
  'pay.cancelPostingConfirmAction': 'Annuller regnskapsføringen',
  'pay.keepPosting': 'Behold regnskapsføringen',
  'pay.seeAccountingVoucher': 'Se regnskapsbilag',
  'pay.registerPayments': 'Registrer utbetalinger',
  'pay.payrollDone': 'Lønnen er kjørt og regnskapsført!',
  'pay.payrollDoneSub': 'Lønnsutbetalingen er ferdig innsendt, regnskapsført og bokført som utbetalt.',
  'pay.allPayrollRuns': 'Alle lønnsutbetalinger',
  'pay.noEntries': 'Ingen posteringer',
  'pay.calculatedWithholding': 'Beregnet skattetrekk',
  'pay.toPayOut': 'Til utbetaling',
  'pay.activePayrollRuns': 'Aktive lønnsutbetalinger',
  'pay.runsCount': '{{count}} kjøringer',
  'pay.employeesInActiveRuns': '{{count}} ansatte i aktive kjøringer',
  'pay.createNewRunHint': 'Opprett en ny lønnsutbetaling for å hente inn ansatte, faste lønnslinjer og godkjente reiser.',
  'pay.activePayrollRunsHelp': 'En lønnsutbetaling beregner lønn, skattetrekk, feriepenger og arbeidsgiveravgift for en periode. Aktive kjøringer er under arbeid.',
  'pay.newPayrollRun': 'Ny lønnsutbetaling',
  'pay.noActiveRuns': 'Ingen aktive lønnsutbetalinger',
  'pay.earlierPayrollRuns': 'Tidligere lønnsutbetalinger',
  'pay.earlierPayrollRunsHelp': 'Lønnskjøringer der utbetalingen er registrert. Du kan åpne dem for detaljer, lønnsslipper og regnskapsbilag.',
  'pay.orderNumberDate': 'Nyeste utbetaling først',
  'pay.travelAndExpenses': 'Reiser og utlegg',
  'pay.createPayrollRun': 'Opprett ny lønnsutbetaling',
  'pay.payrollRunDate': 'Dato for lønnsutbetaling',
  'pay.payPeriodMonthHelp': 'Måneden lønnen gjelder for. Utbetalingsdatoen kan være en egen dato.',
  'pay.paymentDateHelp': 'Datoen pengene faktisk betales ut. Denne endrer ikke lønnsperioden.',
  'pay.paymentDatePeriodWarning': 'Utbetalingsdatoen er utenfor normal måned for lønnsperioden. Kontroller at lønnsperioden og datoen er riktig.',
  'pay.includeFixedLines': 'Ta med faste lønnslinjer',
  'pay.includeExpenseLines': 'Ta med linjer for utlegg',
  'pay.readyExpenseLineCount': '{count} linjer klare til utbetaling',
  'pay.payPeriodLength': 'Lønnsperiode (opptjeningslengde)',
  'pay.ordinaryWithholding': 'Vanlig forskuddstrekk',
  'pay.useTaxCard': 'Bruk skattekort når tilgjengelig',
  'pay.optionalComment': 'Valgfri kommentar',
  'pay.salaryTypesAndDeductions': 'Lønnstyper og trekk',
  'pay.salaryTypesHelp': 'Lønnstyper styrer hvordan en lønnslinje behandles for AGA, skattetrekk, feriepenger og pensjon.',
  'pay.newSalaryType': 'Ny lønnstype',
  'pay.agaLiableHelp': 'Om lønnstypen inngår i grunnlaget for arbeidsgiveravgift. Haket av = avgiftspliktig.',
  'pay.withholdingLiableHelp': 'Om lønnstypen er trekkpliktig — altså om det skal trekkes forskuddsskatt av beløpet.',
  'pay.holidayPayLiableHelp': 'Om lønnstypen gir feriepengegrunnlag — altså om det opptjenes feriepenger av beløpet.',
  'pay.pension': 'Pensjon',
  'pay.pensionLiableHelp': 'Om lønnstypen inngår i grunnlaget for obligatorisk tjenestepensjon (OTP).',
  'pay.rules': 'Regler',
  'pay.noLiabilityRules': 'Ingen avgifts- eller trekkpliktige regler',
  'pay.noEffect': 'Ingen påvirkning',
  'pay.bonusExamplePh': 'F.eks. Bonus uten feriepenger',
  'pay.benefitInKind': 'Naturalytelse',
  'pay.deduction': 'Trekk',
  'pay.taxFreeAllowance': 'Trekkfri godtgjørelse',
  'pay.overrideNote': 'Endringer lagres som foretakets overstyring av standardtypen.',
  'pay.ratePerMonth': 'Sats (per måned)',
  'pay.calculated': 'Beregnes',
  'pay.changeCountries': 'Endre opptjeningsland/bosatt i land',
  'pay.optionalCommentPh': 'Valgfri kommentar ...',
  'pay.fixedSalaryLines': 'Faste lønnslinjer',
  'pay.fixedSalaryLinesSub': 'Lønnslinjer som gjentas automatisk hver lønnskjøring.',
  'pay.addFixedLine': 'Legg til fast lønnslinje',
  'pay.noFixedLines': 'Ingen faste lønnslinjer',
  'pay.payrollSettings': 'Lønnsinnstillinger',
  'pay.payrollSettingsSub': 'Standardvalg som brukes når Plumme bokfører lønn, arbeidsgiveravgift, feriepenger og pensjon.',
  'pay.contributionAndHoliday': 'Avgift og feriepenger',
  'pay.agaZone': 'Sone arbeidsgiveravgift',
  'pay.holidayPayRate': 'Feriepengesats',
  'pay.pensionOtpShort': 'Pensjon (OTP)',
  'pay.pensionProvider': 'Pensjonsleverandør',
  'pay.providerOrgNo': 'Org.nr. leverandør',
  'pay.otpRate': 'OTP-sats',
  'pay.accountsAndReporting': 'Kontoer og rapportering',
  'pay.payrollAccount': 'Lønnskonto (bank)',
  'pay.withholdingAccount': 'Skattetrekkskonto',
  'pay.firstPayrollYear': 'Første år for føring av lønn',
  'pay.entityNumber': 'Virksomhetsnummer',
  'pay.holidayPayPercent': 'Prosent feriepenger',
  'pay.holidayPayPercentHelp': 'Satsen feriepenger opptjenes med. 10,2 % er lovens minimum; 12 % gjelder ved avtale om fem ukers ferie.',
  'pay.holidayPayMonth': 'Måned for feriepenger',
  'pay.month.january': 'Januar',
  'pay.month.february': 'Februar',
  'pay.month.march': 'Mars',
  'pay.month.april': 'April',
  'pay.month.june': 'Juni',
  'pay.month.july': 'Juli',
  'pay.month.august': 'August',
  'pay.month.september': 'September',
  'pay.month.october': 'Oktober',
  'pay.month.november': 'November',
  'pay.month.december': 'Desember',
  'pay.shift.none': 'Ikke skift',
  'pay.shift.shift': 'Skift',
  'pay.shift.rota': 'Turnus',
  'pay.shift.continuous': 'Døgnkontinuerlig skift',
  'pay.ordinary': 'Vanlig',
  'pay.maritime': 'Maritimt',
  'pay.freelancer': 'Frilanser',
  'pay.pensionOrOtherBenefit': 'Pensjon eller annen ytelse',
  'pay.municipalityAndNumber': 'Kommune og kommunenummer',
  'pay.pickMunicipality': 'Velg kommune',
  'pay.calculationCode': 'Beregningskode',
  'pay.generalIndustries': 'Generelle næringer',
  'pay.agricultureForestry': 'Jordbruk og skogbruk',
  'pay.fishing': 'Fiske og fangst',
  'pay.pensionProviderOtp': 'Pensjonsleverandør (OTP)',
  'pay.withholdingAccounts': 'Trekkontoer',
  'pay.payoutAccount': 'Konto for lønnsutbetaling',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Hver måned',
  'pay.everyPayrollRun': 'Ved hver lønnskjøring',
  'pay.taxCardChangeAlert': 'Varsling ved endring av skattekort',
  'pay.emailPh': 'navn@firma.no',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Sparekonto',
  'pay.withholdingMode.fiftyPercent': '50 % forskuddstrekk',
  'pay.withholdingMode.standardHint': 'Bruker gyldig skattekort registrert på den ansatte. Mangler det, trekkes 50 %.',
  'pay.withholdingMode.taxCardHint': 'Skattekort hentes ikke automatisk fra Skatteetaten ennå. Plumme bruker skattekortet som er registrert på den ansatte, og trekker 50 % når gyldig skattekort mangler.',
  'pay.withholdingMode.fiftyPercentHint': 'Trekker 50 % av trekkgrunnlaget for alle ansatte i denne lønnskjøringen, uavhengig av skattekort.',
  'pay.holidayPayPrevious.hint': 'Opptjent i fjor er beregnet fra godkjente lønnskjøringer i fjor, minus det som allerede er utbetalt. Feriepenger opptjent før du tok i bruk Plumme er ikke med – juster beløpet med blyanten.',
  'pay.deductionAccount.label': 'Konto trekket krediteres',
  'pay.deductionAccount.hint': 'Trekk som betales videre til andre er gjeld. Velg 2610 for utleggstrekk. Plumme rapporterer ikke utleggstrekk i a-meldingen – trekket må betales videre separat.',
  'pay.deductionAccount.canteen': '5919 Trekk kantinekostnader ansatte',
  'pay.deductionAccount.garnishment': '2610 Utleggstrekk',
  'pay.deductionAccount.unionDues': '2650 Trukket fagforeningskontingent',
  'pay.deductionAccount.other': '2690 Andre trekk',

  // Special tax rules and pension premium allocation (2026-09-27).
  'pay.taxRuleUnsupportedError': 'Plumme støtter ikke {rule} ennå – kjør lønnen for {employee} utenfor Plumme.',
  'err.payroll.unsupportedTaxRule': 'En ansatt i lønnskjøringen har en skatte- og avgiftsregel Plumme ikke støtter ennå. Kjør lønnen for denne ansatte utenfor Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen og bilandene',
  'pay.taxRules.seafarerDeduction': 'særskilt fradrag for sjøfolk',
  'pay.taxRules.charity': 'veldedig eller allmennyttig organisasjon',
  'pay.taxRules.netPay': 'nettolønn',
  'pay.taxRules.netPaySeafarer': 'nettolønn for sjøfolk',
  'pay.taxRules.pensionSourceTax': 'kildeskatt på pensjoner',
  'pay.taxRules.nanny': 'dagmamma i barnets hjem',
  'pay.taxRules.homeWork': 'lønnsarbeid i hjemmet',
  'pay.taxRules.taxFreeOrganization': 'skattefri organisasjon',
  'pay.pensionAllocation.explain': 'Premien erstatter beregnet OTP for de ansatte du velger. Velger du flere, fordeles beløpet etter OTP-grunnlaget deres.',
  'pay.pensionAllocation.employees': 'Ansatte premien gjelder',
  'pay.pensionAllocation.amountRequired': 'Oppgi et beløp større enn 0.',
  'pay.pensionAllocation.noEmployees': 'Velg minst én ansatt premien gjelder.',
  'pay.pensionAllocation.noBasis': 'De valgte ansatte har ikke noe OTP-grunnlag i denne lønnskjøringen. Velg én ansatt, eller legg inn lønn først.',
  'pay.pensionAllocation.noLines': 'Lønnskjøringen har ingen ansatte å knytte pensjonspremien til.',
  'pay.pensionAllocation.saveFailed': 'Kunne ikke registrere pensjonspremien.',
  // Travel and expense claims paid through one run only (H9, 2026-09-27).
  'pay.travelNotPayableError': 'Disse reiseregningene eller utleggene kan ikke lenger utbetales i denne lønnskjøringen: {travels}. De er allerede utbetalt i en annen kjøring eller er ikke godkjent. Fjern dem fra utkastet, eller reverser kjøringen som utbetalte dem.',
  'err.payroll.travelNotPayable': 'En reiseregning eller et utlegg i lønnskjøringen er allerede utbetalt i en annen kjøring, eller er ikke lenger godkjent. Fjern linjen fra utkastet før du godkjenner.',

  // Payroll-pay-types.jsx i18n batch 1 (2026-09-29).
  'pay.noCalculationBasis': 'Ingen beregningsgrunnlag',
  'pay.payTypeGroup.common': 'Vanlige',
  'pay.payTypeGroup.custom': 'Egne lønnstyper',
  'pay.payTypeGroup.other': 'Andre lønnstyper',
  'pay.payTypeGroup.benefitInKind': 'Naturalytelser',
  'pay.payTypeGroup.deduction': 'Trekk',
  'pay.payTypeGroup.taxFreeAllowance': 'Trekkfrie godtgjørelser',
  'pay.inactive': 'inaktiv',
  'pay.selectSalaryType': 'Velg lønnstype',
  'pay.searchSalaryTypeOrRule': 'Søk etter lønnstype eller regel',
  'pay.showMoreSalaryTypes': 'Vis flere lønnstyper',
  'pay.calculationRules': 'Beregningsregler',

  // Payroll.jsx i18n batch 1 (2026-09-29).
  'pay.agaAndTaxTab': 'Arbeidsgiveravgift og skatt',
  'pay.pensionOtpTab': 'Pensjon/OTP',
  'pay.zone': 'Sone',
  'pay.status.paid': 'Betalt',
  'pay.status.unpaid': 'Ikke betalt',
  'pay.status.approved': 'Godkjent',
  'pay.status.annulled': 'Annullert',
  'pay.status.draft': 'Utkast',
  'pay.status.partiallyPaid': 'Delvis betalt',
  'pay.select': 'Velg',
  'pay.search': 'Søk',
  'pay.noDataYet': 'Ingen data ennå',
  'pay.noDataYetBody': 'Når det finnes registreringer, vises de her.',
  'pay.notSet': 'Ikke satt',
  'pay.thisIsADeduction': 'Dette er et trekk',
  'pay.fixedLineHint.payout': 'Linjen utbetales til den ansatte',
  'pay.fixedLineHint.taxable': 'Trekkpliktig - inngår i forskuddstrekket',
  'pay.fixedLineHint.employerContribution': 'Inngår i grunnlaget for arbeidsgiveravgift',
  'pay.fixedLineHint.holidayPay': 'Inngår i feriepengegrunnlaget',
  'pay.fixedLineHint.pension': 'Inngår i grunnlaget for pensjon (OTP)',
  'pay.fixedLineHint.deduction': 'Negativt beløp - trekkes fra utbetalingen',
  'pay.amountMustBePositive': 'Beløpet må være større enn 0.',
  'pay.amountExceedsOpenTerm': 'Beløpet kan ikke være høyere enn det som står åpent på terminen.',
  'pay.allocationMustMatchAmount': 'Fordelingen må være lik beløpet og kan ikke overstige åpne beløp.',
  'pay.paymentUpdated': 'Betaling oppdatert.',
  'pay.paymentRegistered': 'Betaling registrert.',
  'pay.savePaymentFailed': 'Kunne ikke lagre betaling.',
  'pay.paymentAnnulled': 'Betaling annullert.',
  'pay.annulPaymentFailed': 'Kunne ikke annullere betaling.',
  'pay.allPensionPaymentsRegistered': 'Alle pensjonsinnbetalinger er registrert.',
  'pay.noOtpToRegisterYet': 'Ingen beregnet OTP å registrere ennå.',
  'pay.missingPayrollRunForOtp': 'Mangler lønnskjøring for OTP-betalingen.',
  'pay.pensionPaymentRegistered': 'Pensjonsbetaling registrert.',
  'pay.registerPensionPaymentFailed': 'Kunne ikke registrere pensjonsbetaling.',
  'pay.explainRuleOverrideRequired': 'Begrunn hvorfor beregningsreglene overstyres.',
  'pay.navRefundsFetched': 'NAV-refusjoner hentet.',
  'pay.navRefundsFetchFailed': 'Kunne ikke hente refusjoner fra NAV.',
  'pay.payslipDownloaded': 'Lønnsslipp lastet ned.',
  'pay.payslipDownloadFailed': 'Kunne ikke laste ned lønnsslipp.',
  'pay.payslipsDownloaded': 'Lønnsslipper lastet ned.',
  'pay.payslipsDownloadFailed': 'Kunne ikke laste ned lønnsslipper.',
  'pay.paymentInfoCopied': 'Utbetalingsinformasjon kopiert.',
  'pay.paymentFileDownloaded': 'Utbetalingsfil lastet ned.',
  'pay.linkInboxDocumentFailed': 'Kunne ikke knytte bilag fra innboksen.',
  'pay.payrollRunCreated': 'Lønnsutbetaling opprettet.',
  'pay.payrollRunCreateFailed': 'Kunne ikke opprette lønnsutbetaling.',
  'pay.payrollRunUpdateFailed': 'Kunne ikke oppdatere lønnsutbetalingen.',
  'pay.deletedPayrollRunRemoved': 'Slettet lønnsutbetaling fjernet.',
  'pay.removePayrollRunFailed': 'Kunne ikke fjerne lønnsutbetalingen.',
  'pay.commentSaved': 'Kommentar lagret.',
  'pay.salaryLineAdded': 'Lønnslinje lagt til.',
  'pay.voucherLinkedToPayrollRun': 'Bilag knyttet til lønnsutbetalingen.',
  'pay.salaryTypeSaved': 'Lønnstype lagret.',
  'pay.salaryTypeSaveFailed': 'Kunne ikke lagre lønnstype.',
  'pay.fixedLineSaved': 'Fast lønnslinje lagret.',
  'pay.fixedLineSaveFailed': 'Kunne ikke lagre fast lønnslinje.',
  'pay.fillNameAndAccountNumber': 'Fyll inn navn og kontonummer.',
  'pay.accountAdded': 'Konto lagt til.',
  'pay.addAccountFailed': 'Kunne ikke legge til konto.',
  'pay.calculationCodeNotSupported': 'Denne beregningskoden for arbeidsgiveravgift er ikke støttet ennå. Velg Generelle næringer.',
  'pay.payrollSettingsSaved': 'Lønnsinnstillinger lagret.',
  'pay.payrollSettingsSavedWithRecalc': 'Lønnsinnstillinger lagret. {count} åpne lønnsutkast er beregnet på nytt.',
  'pay.payrollSettingsSaveFailed': 'Kunne ikke lagre lønnsinnstillinger.',
  'pay.markedManualSubmission': 'Markert som manuell innsending.',
  'pay.ameldingSentToAltinn': 'A-melding sendt til Altinn.',
  'pay.payslipsCreatedAndPosted': 'Lønnsslipper opprettet og lønn regnskapsført. Lønnsslippene kan sendes senere.',
  'pay.payrollRunEditableAgain': 'Lønnsutbetalingen kan endres igjen.',
  'pay.accountingAnnulled': 'Regnskapsføringen er annullert.',
  'pay.payrollRunAnnulled': 'Lønnsutbetaling annullert.',
  'pay.payoutRegistered': 'Utbetaling registrert.',
  'pay.confirmAnnulPayment': 'Annullere denne betalingen? Regnskapsposteringen reverseres ved at betalingen ikke lenger tas med.',
  'pay.hideDeletedPayrollRuns': 'Skjul slettede lønnsutbetalinger',
  'pay.showDeletedPayrollRuns': 'Vis slettede lønnsutbetalinger ({count})',
  'pay.removePermanently': 'Fjern permanent',
  'pay.removeDeletedPayrollRunPermanently': 'Fjern slettet lønnsutbetaling permanent',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Fjerne slettet lønnsutbetaling?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'Dette fjerner utkastet for {period} permanent. Bare lønn som aldri er godkjent, sendt eller bokført kan fjernes her.',
  'pay.editPaymentTitle': 'Rediger betaling',
  'pay.registerPaymentTitle': 'Registrer betaling',
  'pay.savingEllipsis': 'Lagrer...',
  'pay.savePaymentAction': 'Lagre betaling',
  'pay.editSalaryTypeTitle': 'Rediger lønnstype',
  'pay.newFixedLineTitle': 'Ny fast lønnslinje',
  'pay.editFixedLineTitle': 'Rediger fast lønnslinje',
  'pay.operatingAccount': 'Driftskonto',
  'pay.newWithholdingAccountTitle': 'Ny skattetrekkskonto',
  'pay.newPayrollAccountTitle': 'Ny lønnskonto',
  'pay.addAccountAction': 'Legg til konto',
  'pay.totalPay': 'Samlet lønn',
  'pay.taxDeduction': 'Skattetrekk',
  'pay.voucher': 'Bilag',
  'pay.basis': 'Grunnlag',
  'pay.payrollRuns': 'Lønnskjøringer',
  'pay.agaOfHolidayPayFull': 'AGA av feriepenger',
  'pay.deadline': 'Frist',
  'pay.paidAmount': 'Betalt',
  'pay.remaining': 'Gjenstår',
  'pay.provider': 'Leverandør',
  'pay.orgNumber': 'Org.nr.',
  'pay.earnedAtStandardRate': 'Opptjent (10,2 %)',
  'pay.ameldingRegistered': 'A-melding registrert',
  'pay.noSubmissions': 'Ingen innsendinger',
  'pay.posted': 'Bokført',
  'pay.notPosted': 'Ikke bokført',
  'pay.payslipsNotGenerated': 'Lønnsslipper er ikke generert.',
  'pay.employmentSetOnEmployeePage': 'Arbeidsforhold settes på ansatt-siden',
  'pay.rulesFromSalaryType': 'Regler fra lønnstypen',
  'pay.useStandardRules': 'Bruk standardreglene',
  'pay.advancedSettings': 'Avanserte innstillinger',
  'pay.overrideCanChangeCalculation': 'Overstyring kan endre skatt, arbeidsgiveravgift, feriepenger, OTP og bokføring for denne linjen.',
  'pay.removeFromFixedLines': 'Fjern denne fra faste lønnslinjer',
  'pay.makeThisAFixedLine': 'Gjør denne til en fast lønnslinje',
  'pay.withholdingExceedsCashPayWarning': 'Forskuddstrekket er høyere enn kontantlønn og refusjoner. Legg til kontantlønn eller reduser trekket før lønnskjøringen kan godkjennes.',
  'pay.attachDocumentationHint': 'Legg ved dokumentasjon på lønnsutbetaling, for eksempel timelister eller manuelle reiseregninger.',
  'pay.upload': 'Last opp',
  'pay.step1AltinnHelp': 'Når alle linjer er med, er neste steg å innrapportere lønnsutbetalingen. Altinn-integrasjonen kobles på senere, så meldingen kan markeres som manuell innsending nå.',
  'pay.step3PayslipsHelp': 'Når lønnsutbetalingen er innrapportert og godkjent, opprettes lønnsslipper og lønnen regnskapsføres.',
  'pay.step4PaymentHelp': 'Registrer og regnskapsfør utbetaling av lønn til ansatte og forskuddstrekk til Skatteetaten.',
  'pay.payrollRunCompletesWhenPaid': 'Lønnsutbetalingen fullføres når betaling er registrert.',
  'pay.productionSupportedProfile': 'Produksjonsstøttet profil: norsk lønn, månedsperiode, Generelle næringer og prosentkort. Tabellkort, særskilte AGA-koder og elektronisk innsending uten kvittering er blokkert.',
  'pay.searchMunicipalityOrNumber': 'Søk kommune eller nummer',
  'pay.notSupportedYet': 'ikke støttet ennå',
  'pay.chooseGeneralIndustriesWarning': 'Velg Generelle næringer før innstillingene kan lagres. Den tidligere valgte beregningskoden er ikke implementert.',
  'pay.searchProvider': 'Søk leverandør',
  'pay.month.may': 'Mai',
  'pay.payTypeNotFixedLine': 'Denne lønnstypen kan ikke brukes som fast lønnslinje.',
  'pay.calculationCodeUnsupportedShort': 'Denne beregningskoden for arbeidsgiveravgift er ikke støttet ennå.',
  'pay.overtimePay': 'Overtid',
  'pay.mileageAllowance': 'Kilometergodtgjørelse',
  'pay.driveFallback': 'Kjøring',
  'pay.taxableMileagePortion': 'Trekkpliktig del',
  'pay.expenseCategoryOther': 'Annet',
  'pay.overnightStayFallback': 'Overnatting',
  'pay.hotelFallback': 'Hotell',
  'pay.mileagePayoutFallback': 'Kjøregodtgjørelse',
  'pay.ownCar': 'Egen bil',
  'pay.travelPurposeFallback': 'Reise',
  'pay.taxTermWithholdingLabel': 'Forskuddstrekk {{date}}',
  'pay.taxTermAgaLabel': '{{term}}. termin',
  'pay.payrollRunNotEditableForNewLines': 'Godkjent lønnskjøring kan ikke få nye lønnslinjer.',
  'pay.payTypeNotManualEntry': 'Denne lønnstypen kan ikke legges til manuelt.',
  'pay.receiptInboxFallbackName': 'Bilag fra innboks',
  'pay.approvedButPayslipsFailed': 'Lønnen er regnskapsført, men lønnsslippene ble ikke sendt: {{error}}',
  'pay.recon.runLabelPeriod': 'Lønn {{period}}',
  'pay.recon.runLabelRun': 'Kjøring {{date}}',
  'pay.recon.notPaid': 'Ikke utbetalt',
  'pay.recon.paidAfterPeriod': 'Utbetalt etter periodedato',
  'pay.recon.flag.negativ_netto': 'Negativ nettolønn',
  'pay.recon.flag.mangler_skattekort': 'Mangler skattekort',
  'pay.recon.flag.sluttet_ansatt': 'Utbetaling til sluttet ansatt',
  'pay.recon.flag.naturalytelse': 'Naturalytelse til kontroll',
  'pay.recon.flag.uvanlig_endring': 'Unormal lønnsendring',
  'pay.recon.flag.mangler_amelding': 'Mangler i A-melding',
  'pay.recon.flag.mulig_duplikat': 'Mulig dobbeltutbetaling',
  'pay.recon.flag.ikke_utbetalt': 'Ikke utbetalt',
  'pay.recon.unknownEmployee': 'Ukjent ansatt',
  'pay.recon.employmentTypeFixed': 'Fast',
  'pay.recon.reported': 'Meldt',
  'pay.recon.notReported': 'Ikke meldt',
  'pay.recon.afterPeriodDate': 'Etter periodedato',
  'pay.recon.role.forskuddstrekk': 'Forskuddstrekk i perioden',
  'pay.recon.role.aga': 'Beregnet arbeidsgiveravgift av lønn',
  'pay.recon.role.aga_feriepenger': 'Beregnet arbeidsgiveravgift av feriepenger',
  'pay.recon.role.feriepenger': 'Feriepengeforpliktelse etter lønnssystemet',
  'pay.recon.role.skyldig_lonn': 'Netto lønn og trekk fra lønnssystemet',
  'pay.recon.role.pensjon': 'Pensjonspremie fra lønnssystemet',
  'pay.recon.row.brutto': 'Bruttolønn',
  'pay.recon.row.naturalytelser': 'Skattepliktige naturalytelser',
  'pay.recon.row.trekkpliktige': 'Trekkpliktige ytelser',
  'pay.recon.row.godtgjorelser': 'Utgiftsgodtgjørelser',
  'pay.recon.row.aga_grunnlag': 'Arbeidsgiveravgiftsgrunnlag',
  'pay.recon.row.aga': 'Beregnet arbeidsgiveravgift',
  'pay.recon.row.netto': 'Netto lønn',
  'pay.recon.row.andre_trekk': 'Andre trekk',
  'pay.recon.row.feriepenger': 'Feriepenger opptjent',
  'pay.recon.row.pensjon': 'Pensjonspremie',
  'pay.recon.source.payrollSystem': 'Lønnssystem',
  'pay.recon.source.bankPayouts': 'Bankutbetalinger',
  'pay.recon.source.pensionBasis': 'Pensjonsgrunnlag',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} bokført kjøring i perioden',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} bokførte kjøringer i perioden',
  'pay.recon.source.payrollSystemDetailEmpty': 'Ingen bokførte lønnskjøringer i perioden',
  'pay.recon.source.ledgerDetail': '{{count}} posteringer på lønnskontoene',
  'pay.recon.source.ledgerDetailEmpty': 'Ingen posteringer på kontoene som er lagt til lønnsområdet',
  'pay.recon.source.ameldingDetailNone': 'Ingen kjøringer å melde',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} av {{total}} kjøringer er registrert som meldt',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} av {{total}} kjøringer er ikke registrert som meldt',
  'pay.recon.source.bankDetailNone': 'Ingen kjøringer å betale',
  'pay.recon.source.bankDetailPaid': '{{paid}} av {{total}} kjøringer er registrert som utbetalt',
  'pay.recon.source.pensionDetailPresent': 'Pensjonspremie beregnet av lønnssystemet',
  'pay.recon.source.pensionDetailNone': 'Ingen pensjonspremie i perioden',
  'pay.recon.check.bokfort': 'Alle lønnskjøringer er bokført',
  'pay.recon.check.hovedbok': 'Lønnssystemet stemmer med hovedboken',
  'pay.recon.check.kontrollkontoer': 'Kontrollkontoene stemmer med grunnlaget',
  'pay.recon.check.bank': 'Netto lønn er utbetalt',
  'pay.recon.check.amelding': 'A-melding er registrert levert',
  'pay.recon.check.skattekort': 'Alle ansatte har gyldig skattekort',
  'pay.recon.check.negativ': 'Ingen negative nettobeløp',
  'pay.recon.check.duplikat': 'Mulige dobbeltutbetalinger er identifisert',
  'pay.recon.check.uvanlig': 'Unormale lønnsendringer er identifisert',
  'pay.recon.check.sluttet': 'Utbetalinger til sluttede ansatte er identifisert',
  'pay.recon.check.naturalytelse': 'Naturalytelser er analysert',
  'pay.recon.check.feriepenger': 'Feriepengeforpliktelsen er avstemt',
  'pay.recon.check.termin': 'Forskuddstrekk og arbeidsgiveravgift er gjort opp',
  'pay.creatingRun': 'Oppretter…',
  'pay.pensionPremiumAmount': 'Faktisk pensjonspremie',
  'pay.pensionBankAmount': 'Betalt fra bank',
  'pay.pensionFeeAmount': 'Særskilt gebyr (brutto)',
  'pay.pensionFeeVat': 'MVA på gebyr',
  'pay.pensionFeeAccount': 'Kostnadskonto for gebyr',
  'pay.pensionOverpaymentNotice': 'Differansen bokføres som forskudd til pensjonsleverandøren på konto 1570.',
  'pay.createLaterCorrection': 'Opprett korreksjon i senere periode',
  'pay.createCorrection': 'Opprett korreksjon',
  'pay.laterCorrectionHelp': 'Originalkjøringen beholdes. Når korreksjonen godkjennes, bokføres bare differansen i den nye perioden.',
  'pay.correctionCreated': 'Korreksjonskjøringen er opprettet som utkast.',
  'pay.typeStandard': 'Standard',
  'pay.typeCustom': 'Egen',
  'pay.statusInactive': 'Inaktiv',
  'pay.ruleTag.aga': 'AGA',
  'pay.ruleTag.tax': 'Skatt',
  'pay.ruleTag.holiday': 'Fer.p.',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Arbeidsgiveravgiftspliktig',
  'pay.ruleTitle.tax': 'Trekkpliktig',
  'pay.ruleTitle.holiday': 'Feriepengegrunnlag',
  'pay.ruleTitle.pension': 'Pensjonsgrunnlag',
  'pay.stdType.monthly-salary': 'Fastlønn',
  'pay.stdType.hourly': 'Timelønn - ikke overtid',
  'pay.stdType.overtime-hourly': 'Timelønn - overtid',
  'pay.stdType.commission-pay': 'Honorar, akkord, prosent eller provisjonslønn',
  'pay.stdType.bonus-holiday-pay': 'Bonus, feriepengeopptjenende',
  'pay.stdType.bonus-no-holiday-pay': 'Bonus, ikke feriepengeopptjenende',
  'pay.stdType.board-fee': 'Styrehonorar',
  'pay.stdType.company-car': 'Fri bil',
  'pay.stdType.other-benefits': 'Andre fordeler',
  'pay.stdType.taxable-insurance': 'Forsikringer, skattepliktig del',
  'pay.stdType.car-km-allowance': 'Kilometergodtgjørelse',
  'pay.stdType.car-km-allowance-taxable': 'Kilometergodtgjørelse, trekkpliktig del',
  'pay.stdType.holiday-pay-current': 'Feriepenger opptjent inneværende år',
  'pay.stdType.holiday-pay-previous': 'Feriepenger opptjent tidligere år',
  'pay.stdType.pension-premium': 'Pensjonspremie OTP',
  'pay.stdType.canteen-deduction': 'Kantinetrekk',
  'pay.stdType.holiday-deduction': 'Trekk i lønn for ferie',
  'pay.stdType.extra-tax-deduction': 'Ekstra skattetrekk',
  'pay.stdType.employee-expense-settlement': 'Utleggsrefusjon reise',
  'pay.stdType.overnight-diet-hotel': 'Diett ved overnatting',
});
